import React from 'react';
import { useThemeStore } from '../state/theme';
import { IBrand } from '../types/brand';
import { useCalenderState } from '../state/calender-state';
import moment from 'moment';
import InvoiceBreadCrumbs from './InvoiceBreadCrumbs';

const InvoiceHeader: React.FC<{
  defaultBrand?: string;
  brands: IBrand[];
  selectedBrand: string | undefined;
  setSelectedBrand: (brand?: string) => void;
  agentName: string;
  hideDateSelector?: boolean;
}> = ({
  defaultBrand,
  brands,
  selectedBrand,
  setSelectedBrand,
  agentName,
  hideDateSelector = false,
}) => {
  const { isDarkMode } = useThemeStore();
  const { currentDate, setCurrentDate } = useCalenderState();

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentDate(new Date(event.target.value));
  };

  const inputClassName = `px-3 py-2 cursor-pointer rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
    isDarkMode
      ? 'bg-gray-700 border-gray-600 text-gray-100'
      : 'border border-gray-300'
  }`;

  return (
    <div className="flex items-center justify-between gap-4 flex-shrink-0">
      <InvoiceBreadCrumbs agentName={agentName} />;
      <div className="flex items-center gap-2 ">
        {!hideDateSelector && (
          <input
            type="month"
            value={moment(currentDate).format('YYYY-MM')}
            onChange={handleDateChange}
            className={inputClassName}
            onClick={(e) => e.currentTarget.showPicker()}
          />
        )}
        {brands?.length && (
          <select
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
            className={inputClassName}
            defaultValue={defaultBrand}
          >
            {brands.map((brand) => (
              <option key={brand._id} value={brand.alias}>
                {brand?.name || brand?.brand_name}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export default InvoiceHeader;
